import React from 'react';

function LiveOutreachIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0C4.77198 0 1.34358 3.39653 1.28823 7.61133C0.529254 7.97436 0 8.75096 0 9.64286V12.2143C0 13.4497 1.01462 14.4643 2.25 14.4643C3.48538 14.4643 4.5 13.4497 4.5 12.2143V9.64286C4.5 8.51903 3.66064 7.57877 2.57896 7.41797C2.73189 3.98524 5.52688 1.28571 9 1.28571C12.4731 1.28571 15.2681 3.98524 15.421 7.41797C14.3394 7.57877 13.5 8.51903 13.5 9.64286V12.2143C13.5 13.4497 14.5146 14.4643 15.75 14.4643C15.8508 14.4643 15.9502 14.4572 16.0476 14.4442C15.9046 15.3712 15.1128 16.0714 14.1429 16.0714H12.1816C12.0303 15.3431 11.3765 14.7857 10.6071 14.7857H8.67857C7.79934 14.7857 7.07143 15.5136 7.07143 16.3929C7.07143 17.2721 7.79934 18 8.67857 18H10.6071C11.1263 18 11.5929 17.746 11.8878 17.3571H14.1429C15.9104 17.3571 17.3571 15.9104 17.3571 14.1429V13.7825C17.7538 13.3761 18 12.8221 18 12.2143V9.64286C18 8.75096 17.4707 7.97436 16.7118 7.61133C16.6564 3.39653 13.228 0 9 0Z"
        fill="#77787B"
      />
    </svg>
  );
}

export default LiveOutreachIcon;
